module.exports = __webpack_public_path__ + "media/images/external_link_black-c061df4fd5e5bcdf9e6840b123fbd434.png";